// Departments every new org starts with (see CreateOrganization). Their
// colours double as the default palette for things that have no colour of
// their own, e.g. deliverable cards in the client room grid.
export const DEFAULT_DEPARTMENTS = [
  {
    id: "tmp-1",
    name: "Engineering",
    metadata: { bg: "#8B5CF6", border: "#C7D2FE" },
  },
  {
    id: "tmp-2",
    name: "Sales",
    metadata: { bg: "#F97316", border: "#67E8F9" },
  },
  {
    id: "tmp-3",
    name: "Marketing",
    metadata: { bg: "#EC4899", border: "#FDBA74" },
  },
  {
    id: "tmp-4",
    name: "Human Resources",
    metadata: { bg: "#22C55E", border: "#86EFAC" },
  },
  {
    id: "tmp-5",
    name: "Finance",
    metadata: { bg: "#3B82F6", border: "#F5D0FE" },
  },
  {
    id: "tmp-6",
    name: "Research and Development",
    metadata: { bg: "#14B8A6", border: "#E5E7EB" },
  },
];

export const DEFAULT_DEPARTMENT_COLORS = DEFAULT_DEPARTMENTS.map(
  (d) => d.metadata.bg
);
